const STATS = [
  'minutes', 'appearances', 'lineups', 'substitutes',
  'benches', 'goals', 'assists',
]

function processPlayerStats(stats = {}) {
  stats = Object.assign({}, stats)
  for(let key of STATS) {
    stats[key] = stats[key] || 0
  }

  stats.total_minutes = stats.minutes * stats.appearances

  return stats
}

export default {
  processPlayerStats,
};
